import { Link } from "@remix-run/react";
import { type FunctionComponent } from "react";
import clsx from "clsx";
import type { PostListItem } from "~/database/post.model";
import { dateDisplay } from "~/utils/dateDisplay";
import { useGetThum } from "~/utils/dom/useGetThum";

interface PostItemProps {
  data: PostListItem;
  type?: "large" | "small";
  color?: string;
}

const PostItem: FunctionComponent<
  PostItemProps
> = ({ data, type = "small", color }) => {
  const getThum = useGetThum();

  /*   const [randomColor] = useState(
    PR_COLORS[
      Math.floor(Math.random() * PR_COLORS.length)
    ],
  ); */
  console.log('data:', data);
  if(!data){
    return <div></div>;
  }
  return (
    <div className={clsx("relative")}>
      <Link
        to={`/${data.user_display_id}/posts/${data?.display_id}/`}
        className={clsx(
          "block aspect-[16/9] bg-gray-200",
          type === "large"
            ? "max-md:aspect-[1/1]"
            : "max-md:aspect-[16/9]",
          "rounded-[20px]",
          "max-md:rounded-[10px]",
          "overflow-hidden",
        )}
      >
        {data?.thumbnail_path && (
          <img
            src={getThum(data.thumbnail_path)}
            className={clsx(
              "h-full w-full object-cover",
            )}
            alt=""
          />
        )}
      </Link>

      {/*       {type === "small" && (
        <div
          className={clsx(
            "absolute",
            "z-[2]",
            "bottom-36",
            "right-5",
            "text-center",
            "w-18",
            "max-md:bottom-20",
            "max-md:right-15",
          )}
        >
          <FavoBtn
            isFavo={data.is_liked}
            postId={data.id}
          ></FavoBtn>
          <div
            className={clsx(
              "text-10",
              "leading-[1]",
              "mt-4",
            )}
          >
            {data.likes_count}
          </div>
        </div>
      )} */}
      <div className={clsx()}>
        <div
          style={
            {
              /* backgroundColor: data.user_main_color, */
            }
          }
          className={clsx(
            type !== "large" && "min-h-70",
            type !== "large" && "max-md:min-h-50",
            "flex",
            "items-center",
            "items-center",
            //"bg-black bg-opacity-80",
            /* data.user_main_color ??
              color ??
              randomColor, */
            "rounded-[14px]",
            "max-md:rounded-[8px]",
            type === "large" ? "mt-18" : "mt-6",
            /*       type === "large"
              ? "-mt-48"
              : "-mt-16",
            type === "large"
              ? "-ml-28"
              : "-ml-16",
            type === "large"
              ? "max-md:-ml-15"
              : "max-md:-ml-16", */
            /* "w-[90%]", */
            /* "text-white", */
            "relative",
            "z-10",
            /* type === "large" ? "py-20" : "py-12",
            type === "large" ? "px-20" : "px-12", */
            type === "large"
              ? "max-md:mt-20"
              : "max-md:mt-8",
            /* type === "large"
              ? "max-md:py-10"
              : "max-md:py-8", */
            type === "large"
              ? "max-md:px-10"
              : "max-md:px-8",
            type === "large"
              ? "text-30"
              : "text-17",
            type === "large"
              ? "max-md:text-20"
              : "max-md:text-13",
            type === "large"
              ? "leading-[1.3]"
              : "leading-[1.5]",
            "font-bold",
          )}
        >
          <div className={clsx("line-clamp-3")}>
            {data?.title}
          </div>
        </div>
      </div>

      <div
        className={clsx(
          "flex",
          "items-center",
          "tracking-1",
          "text-sm",
          "text-gray-400",
          type === "large" ? "mt-10" : "mt-2",
          "text-12",
          "max-md:text-12",
        )}
      >
        <div
          className={clsx(
            "font-bold",
            "line-clamp-1",
          )}
          style={{
            color: data?.user_main_color,
          }}
        >
          <Link to={`/user/${data?.user_id}/`}>
            {data?.user_name}
          </Link>
        </div>
        <div
          className={clsx(
            "pl-8",
            "ml-8",
            "border-l",
            "whitespace-nowrap",
          )}
        >
          {dateDisplay(
            data?.first_published_at ??
              data?.created_at,
          )}
        </div>
      </div>
      {/* {data.user_id === root?.user?.id && (
        <Link
          to={`/posts/edit/${data.id}/`}
          className={clsx("underline", "text-sm ")}
        >
          編集
        </Link>
      )} */}
    </div>
  );
};

export default PostItem;
